import React from "react";
import LegalLink from "./LegalLink";
import { OFFER_PATH, SELLER_NAME } from "./operator";

/** Оферта принимается оплатой — строка под кнопкой «Оплатить». */
function OfferNotice({ className = "", linkClassName = "" }) {
  return (
    <p className={className}>
      Нажимая «Оплатить», вы соглашаетесь с условиями{" "}
      <LegalLink
        href={OFFER_PATH}
        tip={`Продавец — ${SELLER_NAME}`}
        className={linkClassName}
      >
        оферты
      </LegalLink>
    </p>
  );
}

export default OfferNotice;
